import React from 'react';
import {useDrag} from 'react-dnd';

const TaskAnswerItem = ({word, isSelected, onSelect}) => {
  const [{isDragging, position}, drag] = useDrag({
    item: {
      type: 'answer',
      word,
    },
    collect: monitor => ({
      position: monitor.getClientOffset(),
      isDragging: !!monitor.isDragging(),
    }),
  });

  const pos = position || {};

  return (
    <div>
      <div
        ref={drag}
        onClick={() => onSelect(word)}
        className="answer-item border border-dark user-select-none rounded mb-2 px-3 py-1 text-center"
        style={{
          opacity: isDragging ? '0.5' : '1',
          color: isSelected ? 'white' : undefined,
          backgroundColor: isSelected ? '#c89603' : '#ffc415',
        }}
      >
        {word}
      </div>
      {isDragging && (
        <div
          className="answer-item border border-dark bg-warning user-select-none rounded mb-2 px-3 py-1 text-center position-fixed"
          style={{position: 'fixed', left: pos.x, top: pos.y}}
        >
          {word}
        </div>
      )}
    </div>
  );
};

export default TaskAnswerItem;
